import verifyValidText from "lib/verifyValidText";

export default function verifyEmail(value) {
  // eslint-disable-next-line unicorn/regex-shorthand
  const patternEmail = /^[\w._-]+[+]?[\w._-]+@[\w.-]+\.[a-zA-Z]{2,6}$/;
  return verifyValidText(value) && patternEmail.test(value);
}
